module.exports = __webpack_public_path__ + "static/media/charger-pin-private.f807f061.png";